/**
 * Don't forget, the current naming convention is in the format of:
 * PROJECT-NUMBER-short-feature-enabled
 * PROJECT-NUMBER-permanent-feature-enabled
 * e.g. "XP-3179-short-maps-auto-bound-enabled"
 * @see {@link https://sweetgreen.atlassian.net/wiki/spaces/TD/pages/4528570450/Feature+Flags#%F0%9F%93%9B-Naming-Conventions Naming Conventions}
 *
 * We track feature flag deletions in this spreadsheet:
 * @see {@link https://docs.google.com/spreadsheets/d/1gm_97S3nVXb2ptnaGkg7uCHRnZmkSr1XSnqG77Yj4ew/edit#gid=0 Feature Flag Removal}
 * Please create a ticket for removing short term feature flags that you created and include it there.
 */

export const featureFlagDefaults = {
  'OPS-sweetpass-beta-enabled': false,
  'CELS-440-long-sweetpass-detailed-hero-stats-enabled': false,
  'permanent-forced-app-update-enabled': false,
  'permanent-order-crash-option-enabled': false,
  'permanent-contentful-preview-enabled': false,

  // !! ───────────────────────────────────────────────────────────────────────
  // !!                           W A R N I N G                              !!
  // !! ───────────────────────────────────────────────────────────────────────
  // !! Most flags should be `true` by default.                              !!
  // !! Flag that are `false` by default are very difficult to remove later. !!
  // !! Please consider if your flag should be `false` before committing it. !!
  // !! It should be reserved for flags that should be `false` if deleted.   !!
  // !! Usually this means special features that aren't always turned on.    !!
  // !! ───────────────────────────────────────────────────────────────────────

  'permanent-scan-to-pay-enabled': true,
  'permanent-scan-to-pay-shake-listener-enabled': true,
  'permanent-in-app-review-enabled': true,
  'permanent-apple-wallet-enabled': true,
  'permanent-app-tracking-transparency-enabled': true,
  'permanent-refer-friend-enabled': true,
  'XP-3232-permanent-order-to-healthkit-enabled': true,

  'XP-3179-short-maps-auto-bound-enabled': true,
  'XP-3179-short-maps-offset-enabled': true,
  'XP-3189-short-disable-search-controls-while-fetching-locations': true,
  'XP-3156-short-locations-results-redesign': true,
  'XP-3260-short-enable-caching-support-for-pdp-state-machine': true,
  'XP-3273-short-enable-location-search-component-enabled': true,
  'XP-3273-short-location-search-component-in-reorder-enabled': true,

  'OPS-kustomer-enabled': true,
  'OPS-challenges-enabled': true,
  'OPS-enable-maintenance-mode': true,
  'OPS-contentful-enabled': true,
  'OPS-ca-data-request': true,
  'OPS-sweetpass-enabled': true,
  'OPS-customer-decoupling-login-enabled': true,

  'MNU-656-deeplink-continue-button-enabled': true,
  'MNU-834-short-term-sum-calories-enabled': true,

  'CELS-618-short-custom-sweetpass-braze-events-enabled': true,
  'cels-763-short-rework-the-authentication-redirect-flow-enabled': true,
  'CELS-487-short-new-reward-types-enabled': true,
  'cels-754-enable-tipping-native-pickup': true,
};
